import * as ReactDOMClient from 'react-dom/client'
import {createStrategyRenderers} from './StrategyWidgets'

const renderers = createStrategyRenderers({
  href: '/strategies/periodic-dividends',
  title: 'Дивиденды на каждый день',
  description: 'Акции российских компаний с регулярными дивидендными событиями.',
  annualYield: '+15% в год',
})

const registerPeriodicDividendsStrategyWidgets = () => {
  window.createRoot = (element) => ReactDOMClient.createRoot(element)
  window.renderPeriodicDividendsStrategyWidget = renderers.renderPerformance
  window.renderPeriodicDividendsStrategyStatisticsWidget = renderers.renderStatistic
  window.renderPeriodicDividendsStrategyPortfolioWidget = renderers.renderPortfolio
}

export {registerPeriodicDividendsStrategyWidgets}
